var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: 'scrollbar-datepicker'
      },
      expression: "{\n      id: 'scrollbar-datepicker',\n    }"
    }],
    ref: "scrollbar",
    class: _vm.$style.content
  }, _vm._l(_vm.months, function (month, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.palette
    }, [_c('datepicker-palette', {
      ref: "month",
      refInFor: true,
      attrs: {
        "min": _vm.min,
        "max": _vm.max,
        "range": _vm.range,
        "value": _vm.value,
        "month": month,
        "hover-day": _vm.hoverDay,
        "first-day-offset": _vm.firstDayOffset,
        "is-mobile": ""
      },
      on: {
        "input": _vm.onInputValue,
        "hover:day": function hoverDay($event) {
          _vm.hoverDay = $event;
        }
      }
    })], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }